/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Checklist } from '../models/Checklist';
import type { ChecklistDefinitionCreateDto } from '../models/ChecklistDefinitionCreateDto';
import type { ChecklistDefinitionUpdateDto } from '../models/ChecklistDefinitionUpdateDto';
import type { ChecklistItemDto } from '../models/ChecklistItemDto';
import type { ChecklistListDto } from '../models/ChecklistListDto';
import type { WorkflowDefinition } from '../models/WorkflowDefinition';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class ChecklistDefinitionService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Get all checklist definitions workflows from the DB.
     * @param orgGuid
     * @returns ChecklistListDto OK
     * @throws ApiError
     */
    public getAllChecklistDefinitions(
        orgGuid: string,
    ): CancelablePromise<Array<ChecklistListDto>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/ChecklistDefinition/{orgGuid}/GetAllChecklistDefinitions',
            path: {
                'orgGuid': orgGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Get all checklist definitions for a specific workflow from the form definition.
     * @param formDefinitionGuid
     * @param orgGuid
     * @returns ChecklistItemDto OK
     * @throws ApiError
     */
    public getAllChecklistsForWorkflow(
        formDefinitionGuid: string,
        orgGuid: string,
    ): CancelablePromise<Array<ChecklistItemDto>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/ChecklistDefinition/{orgGuid}/{formDefinitionGuid}/GetAllChecklistsForWorkflow',
            path: {
                'formDefinitionGuid': formDefinitionGuid,
                'orgGuid': orgGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param checklistGuid
     * @param orgGuid
     * @returns Checklist OK
     * @throws ApiError
     */
    public getChecklistDefinition(
        checklistGuid: string,
        orgGuid: string,
    ): CancelablePromise<Checklist> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/ChecklistDefinition/{orgGuid}/{checklistGuid}/GetChecklistDefinition',
            path: {
                'checklistGuid': checklistGuid,
                'orgGuid': orgGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Get all checklists associated with a compliance checklist.
     * @param checklistDefinitionGuid The checklist's guid.
     * @param orgGuid
     * @returns WorkflowDefinition OK
     * @throws ApiError
     */
    public getWorkflowsAssociatedWithChecklist(
        checklistDefinitionGuid: string,
        orgGuid: string,
    ): CancelablePromise<Array<WorkflowDefinition>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/ChecklistDefinition/{orgGuid}/{checklistDefinitionGuid}/GetWorkflowsAssociatedWithChecklist',
            path: {
                'checklistDefinitionGuid': checklistDefinitionGuid,
                'orgGuid': orgGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param orgGuid
     * @param requestBody
     * @returns Checklist OK
     * @throws ApiError
     */
    public createChecklistDefinition(
        orgGuid: string,
        requestBody?: ChecklistDefinitionCreateDto,
    ): CancelablePromise<Checklist> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/ChecklistDefinition/{orgGuid}/CreateChecklistDefinition',
            path: {
                'orgGuid': orgGuid,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param checklistGuid
     * @param orgGuid
     * @param requestBody
     * @returns Checklist OK
     * @throws ApiError
     */
    public updateChecklistDefinition(
        checklistGuid: string,
        orgGuid: string,
        requestBody?: ChecklistDefinitionUpdateDto,
    ): CancelablePromise<Checklist> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/ChecklistDefinition/{orgGuid}/{checklistGuid}/UpdateChecklistDefinition',
            path: {
                'checklistGuid': checklistGuid,
                'orgGuid': orgGuid,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param checklistGuid
     * @param orgGuid
     * @returns Checklist OK
     * @throws ApiError
     */
    public deleteChecklistDefinition(
        checklistGuid: string,
        orgGuid: string,
    ): CancelablePromise<Checklist> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/ChecklistDefinition/{orgGuid}/{checklistGuid}/DeleteChecklistDefinition',
            path: {
                'checklistGuid': checklistGuid,
                'orgGuid': orgGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
}
